import { ChangeDetectorRef, Component, SimpleChanges } from '@angular/core';
import { ElementAttribute } from 'src/app/enums/element-attribute';
import { RestApiEndpoints } from 'src/app/enums/rest-api-endpoints';
import { SelectedBurialsTab } from 'src/app/enums/selected-burials-tab';
import { BurialsService } from 'src/app/services/burials.service';
import { CredentialsService } from 'src/app/services/credentials.service';
import { ModalService } from 'src/app/services/modal.service';
import { RestApiService } from 'src/app/services/rest-api.service';

declare function setReadonlyOnInputsToState(readonlyState: boolean, isForced: boolean): void;
declare function initSelect(): void;
declare function initCollapsible(): void;
declare function initBurialDates(callback: (pickerComponent: any, dateTime: any, type: string) => void): void;
declare function getAllowedTimesArray(dateTime: any, type: string): any;
declare function toggleLoadingSpinner(isShown: boolean): void;
declare function setPickerTimeBoxVisible(isVisible: boolean): void;
declare function updateMaterialTextFields(): void; 
declare function makeToast(message: string): void; 

@Component({
  selector: 'app-dates',
  templateUrl: './dates.component.html',
  styleUrls: ['./dates.component.css']
})
export class DatesComponent {

  currentData = this.modalService.getModalData();
  burialDates: any = {};
  anonymousBurialSite: any = null;
  driveServiceDateWishIndicator: boolean = false;
  adoptionTypeIndicator: boolean = false;
  burialServiceDateWishIndicator: boolean = false;
  showInputTreeNumber: boolean = false;
  mourningHallUse: any;
  urnDeliveryDataCache: any;

  constructor(private modalService: ModalService,
    private credentialsService: CredentialsService,
    private burialsService: BurialsService,
    private changeDetectorRef: ChangeDetectorRef,
    private restApiService: RestApiService) {

    if (this.currentData.hasOwnProperty('burialDates')) {
      this.burialDates = this.currentData.burialDates;
    }
  }

  ngAfterViewInit() {
    initCollapsible();
    initSelect();

    setReadonlyOnInputsToState(this.modalService.shouldBeReadOnly, false);

    setTimeout(() => {
      this.insertDataToFields();
      this.initInputFieldsWithValuesFromServer();
    }, 0);

    initBurialDates((pickerComponent: any, dateTime: any, type: string) => {
      this.requestAllowedTimesUpdate(pickerComponent, dateTime, type);
    });
  }
  onChange(event:any){
    alert('change event triggered');

  }
  changeValue() {
  
    // also trigger an event on the input.
    let event = new Event('change');
  }
  
  private equalsZeroString(string: string) {
    return string && !(typeof string === 'undefined') && string === '0';
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  private validateDateTimeRange(fromDate: string, toDate: string): boolean {
    if (!fromDate || !toDate) {
      return true; // Wenn eines der Felder leer ist, ist die Validierung erfolgreich
    }

    const fromDateTime = new Date(fromDate);
    const toDateTime = new Date(toDate);

    if (isNaN(fromDateTime.getTime()) || isNaN(toDateTime.getTime())) {
      return true; // Wenn eines der Datumsformate ungültig ist, überspringen wir die Validierung
    }

    return fromDateTime <= toDateTime;
  }
  didChangeBurialFieldWithClass(fieldClass: string) {
    const field: any = this.credentialsService.parseElementBy(ElementAttribute.class, fieldClass);
    if (!field) { return; }

    let fieldValue = field.value;

    if (fieldClass === 'anonymousBurialSite') {
      this.setValueForKey('anonymousBurialContractOne', '0');
      this.setValueForKey('anonymousBurialContractTwo', '0');
      this.setValueForKey('anonymousBurialContractThree', '0');
      this.setValueForKey('anonymousBurialContractFour', '0');
      this.setValueForKey('anonymousBurialContractFive', '0');
      this.setValueForKey('anonymousBurialContractSix', '0');
      this.setValueForKey('anonymousBurialContractSeven', '0');
      this.setValueForKey('anonymousBurialContractEight', '0');
      this.setValueForKey('anonymousBurialContractNine', '0');
      this.setValueForKey('anonymousBurialContractTen', '0');
      this.setValueForKey('anonymousBurialContractEleven', '0');

      this.setValueForKey('anonymousBurialTypeOne', '0');
      this.setValueForKey('anonymousBurialTypeTwo', '0');
      this.setValueForKey('anonymousBurialTypeThree', '0');
      this.setValueForKey('anonymousBurialContractNine', '0');
      this.setValueForKey('inputNametagSwitch', '0');
      this.setValueForKey('inputTreeNumberSwitch', '0');
      this.setValueForKey('anonymousBurialSiteDateTimeWish', '');
      this.setValueForKey('anonymousBurialSiteInfo', '');
      this.setValueForKey('inputTreeNumber', '');
      this.setValueForKey('inputProvisionNumber', '');

      for (var burialKey in this.burialDates) {
        if (burialKey == 'inputNametagSwitch' || burialKey == 'inputTreeNumberSwitch' || burialKey == 'inputProvisionNumber' || burialKey.indexOf('anonymousBurial') >= 0) {
          delete this.burialDates[burialKey];
        }
      }

      this.modalService.setModalData('burialDates', this.burialDates);
      if (fieldValue == '0') {
        this.burialServiceDateWishIndicator = false;
        this.anonymousBurialSite = null;
        this.changeDetectorRef.detectChanges();
        return;
      }
    }

    if (!fieldValue || fieldValue === '0') {
      let fallbackValue;
      let val = field.value;

      if (!field && !fieldValue) {
        fieldValue = fallbackValue;
      }

      if (!val || val === '0') {
        fallbackValue = val;
      }

      fieldValue = !this.equalsZeroString(fieldValue) ? fieldValue : val;

      if (this.equalsZeroString(fieldValue) && !this.equalsZeroString(fallbackValue)) {
        fieldValue = fallbackValue;
      }
    }

    if (fieldClass.indexOf('Switch') >= 0) {
      fieldValue = field.checked;
      if (fieldValue && fieldValue === true) {
        fieldValue = 1;
      } else {
        fieldValue = 0;
      }
      if (fieldClass == 'inputTreeNumberSwitch') {
        this.showInputTreeNumber = !fieldValue;
      }
      this.changeDetectorRef.detectChanges();
    }

    if ((fieldClass == 'adoptionType' && fieldValue != 0 && fieldValue != 2) || (fieldClass == 'anonymousBurialTypeOne' && fieldValue != 0 && fieldValue != 4)) {
      makeToast('Hier entstehen Zusatzkosten, welche der <a href="https://bestatter-login.de/download/Preisliste DFG.pdf" target="_blank">&nbsp;Preisliste&nbsp;</a> entnommen werden können.');
    } 

    if (fieldClass == 'anonymousBurialContractOne' || fieldClass == 'anonymousBurialContractTwo' || fieldClass == 'anonymousBurialContractThree' || fieldClass == 'anonymousBurialContractFour' || fieldClass == 'anonymousBurialContractFive' || fieldClass == 'anonymousBurialContractSix' || fieldClass == 'anonymousBurialContractSeven' || fieldClass == 'anonymousBurialContractEight' || fieldClass == 'anonymousBurialContractNine' || fieldClass == 'anonymousBurialContractTen' || fieldClass == 'anonymousBurialContractEleven') {
      fieldClass = 'anonymousBurialContract';
    } else if (fieldClass == 'anonymousBurialTypeOne' || fieldClass == 'anonymousBurialTypeTwo' || fieldClass == 'anonymousBurialTypeThree') {
      fieldClass = 'anonymousBurialType';
    }

    var fieldValueChanged = false;
    if (this.burialDates[fieldClass] != fieldValue) {
      fieldValueChanged = true;
    }

    if (fieldClass == 'driveServiceDateTimeWishFrom' || fieldClass == 'driveServiceDateTimeWishTo') {
      const fromDate = this.burialDates['driveServiceDateWishFrom'] + ' ' + this.burialDates['driveServiceTimeWishFrom'];
      const toDate = this.burialDates['driveServiceDateWishTo'] + ' ' + this.burialDates['driveServiceTimeWishTo'];

      if (!this.validateDateTimeRange(fromDate, toDate)) {
        makeToast('Das Enddatum darf nicht vor dem Startdatum liegen.');
        return;
      }
    }

    if (fieldClass == 'driveServiceDateTimeWishFrom') {
      var driveServiceDateTimeWishFromArray = fieldValue.split(' ');
      if (driveServiceDateTimeWishFromArray.length > 1) {

        if (this.burialDates['driveServiceDateWishFrom'] != driveServiceDateTimeWishFromArray[0] || this.burialDates['driveServiceTimeWishFrom'] != driveServiceDateTimeWishFromArray[1]) {
          fieldValueChanged = true;
        }

        this.burialDates['driveServiceDateWishFrom'] = driveServiceDateTimeWishFromArray[0];
        this.modalService.didInputForClass('driveServiceDateWishFrom');
        this.burialDates['driveServiceTimeWishFrom'] = driveServiceDateTimeWishFromArray[1];
        this.modalService.didInputForClass('driveServiceTimeWishFrom');

        // Wenn BIS bereits eingetragen ist, prüfe ob es mindestens 3 Stunden nach VON liegt
        if (this.burialDates['driveServiceDateWishTo'] && this.burialDates['driveServiceTimeWishTo'] &&
            this.burialDates['driveServiceDateWishTo'].length > 0 && this.burialDates['driveServiceTimeWishTo'].length > 0) {
          const fromDate = driveServiceDateTimeWishFromArray[0] + ' ' + driveServiceDateTimeWishFromArray[1];
          const toDate = this.burialDates['driveServiceDateWishTo'] + ' ' + this.burialDates['driveServiceTimeWishTo'];
          
          const fromDateTime = new Date(this.parseGermanDateTime(fromDate));
          const toDateTime = new Date(this.parseGermanDateTime(toDate));
          
          if (!isNaN(fromDateTime.getTime()) && !isNaN(toDateTime.getTime())) {
            const diffHours = (toDateTime.getTime() - fromDateTime.getTime()) / (1000 * 60 * 60);
            
            // Wenn BIS weniger als 3 Stunden nach VON liegt, passe BIS an
            if (diffHours < 3) {
              const newToDateTime = new Date(fromDateTime);
              newToDateTime.setHours(newToDateTime.getHours() + 3);
              
              const newToDate = this.formatGermanDate(newToDateTime);
              const newToTime = this.formatGermanTime(newToDateTime);
              
              this.burialDates['driveServiceDateWishTo'] = newToDate;
              this.burialDates['driveServiceTimeWishTo'] = newToTime;
              
              // Aktualisiere das BIS-Feld im UI
              setTimeout(() => {
                const toField = this.credentialsService.parseElementBy(ElementAttribute.class, 'driveServiceDateTimeWishTo');
                if (toField) {
                  toField.value = newToDate + ' ' + newToTime;
                  this.modalService.didInputForClass('driveServiceDateTimeWishTo');
                }
              }, 0);
              
              makeToast('Hinweis: Die Abholzeit "bis" wurde auf ' + newToTime + ' Uhr angepasst, da zwischen "Abholung von" und "Abholung bis" mindestens 3 Stunden liegen müssen.');
            }
          }
        }

        this.modalService.setModalData('burialDates', this.burialDates);
      }
    } else if (fieldClass == 'driveServiceDateTimeWishTo') {
      var driveServiceDateTimeWishToArray = fieldValue.split(' ');
      if (driveServiceDateTimeWishToArray.length > 1) {

        if (this.burialDates['driveServiceDateWishTo'] != driveServiceDateTimeWishToArray[0] || this.burialDates['driveServiceTimeWishTo'] != driveServiceDateTimeWishToArray[1]) {
          fieldValueChanged = true;
        }

        // Wenn VON noch nicht eingetragen ist, setze es auf das gleiche Datum + Uhrzeit
        if (!this.burialDates['driveServiceDateWishFrom'] || !this.burialDates['driveServiceTimeWishFrom'] || 
            this.burialDates['driveServiceDateWishFrom'].length == 0 || this.burialDates['driveServiceTimeWishFrom'].length == 0) {
          this.burialDates['driveServiceDateWishFrom'] = driveServiceDateTimeWishToArray[0];
          this.modalService.didInputForClass('driveServiceDateWishFrom');
          this.burialDates['driveServiceTimeWishFrom'] = driveServiceDateTimeWishToArray[1];
          this.modalService.didInputForClass('driveServiceTimeWishFrom');
          
          // Setze das VON-Feld im UI
          setTimeout(() => {
            const fromField = this.credentialsService.parseElementBy(ElementAttribute.class, 'driveServiceDateTimeWishFrom');
            if (fromField) {
              fromField.value = fieldValue;
              this.modalService.didInputForClass('driveServiceDateTimeWishFrom');
            }
          }, 0);
        }

        // Prüfe ob BIS mindestens 3 Stunden nach VON liegt
        if (this.burialDates['driveServiceDateWishFrom'] && this.burialDates['driveServiceTimeWishFrom']) {
          const fromDate = this.burialDates['driveServiceDateWishFrom'] + ' ' + this.burialDates['driveServiceTimeWishFrom'];
          const toDate = driveServiceDateTimeWishToArray[0] + ' ' + driveServiceDateTimeWishToArray[1];
          
          const fromDateTime = new Date(this.parseGermanDateTime(fromDate));
          const toDateTime = new Date(this.parseGermanDateTime(toDate));
          
          if (!isNaN(fromDateTime.getTime()) && !isNaN(toDateTime.getTime())) {
            const diffHours = (toDateTime.getTime() - fromDateTime.getTime()) / (1000 * 60 * 60);
            
            // Wenn BIS weniger als 3 Stunden nach VON liegt, passe BIS an
            if (diffHours < 3) {
              const newToDateTime = new Date(fromDateTime);
              newToDateTime.setHours(newToDateTime.getHours() + 3);
              
              const newToDate = this.formatGermanDate(newToDateTime);
              const newToTime = this.formatGermanTime(newToDateTime);
              
              this.burialDates['driveServiceDateWishTo'] = newToDate;
              this.burialDates['driveServiceTimeWishTo'] = newToTime;
              
              // Aktualisiere das BIS-Feld im UI
              setTimeout(() => {
                const toField = this.credentialsService.parseElementBy(ElementAttribute.class, 'driveServiceDateTimeWishTo');
                if (toField) {
                  toField.value = newToDate + ' ' + newToTime;
                  this.modalService.didInputForClass('driveServiceDateTimeWishTo');
                }
              }, 0);
              
              makeToast('Hinweis: Die Abholzeit "bis" wurde auf ' + newToTime + ' Uhr angepasst, da zwischen "Abholung von" und "Abholung bis" mindestens 3 Stunden liegen müssen.');
            } else {
              this.burialDates['driveServiceDateWishTo'] = driveServiceDateTimeWishToArray[0];
              this.burialDates['driveServiceTimeWishTo'] = driveServiceDateTimeWishToArray[1];
            }
          } else {
            this.burialDates['driveServiceDateWishTo'] = driveServiceDateTimeWishToArray[0];
            this.burialDates['driveServiceTimeWishTo'] = driveServiceDateTimeWishToArray[1];
          }
        } else {
          this.burialDates['driveServiceDateWishTo'] = driveServiceDateTimeWishToArray[0];
          this.burialDates['driveServiceTimeWishTo'] = driveServiceDateTimeWishToArray[1];
        }
        
        this.modalService.didInputForClass('driveServiceDateWishTo');
        this.modalService.didInputForClass('driveServiceTimeWishTo');
        this.modalService.setModalData('burialDates', this.burialDates);
      }
    } else if (fieldClass == 'adoptionDateTimeWish') {
      var adoptionDateTimeWishArray = fieldValue.split(' ');
      if (adoptionDateTimeWishArray.length > 1) {

        if (this.burialDates['adoptionDateWish'] != adoptionDateTimeWishArray[0] || this.burialDates['adoptionTimeWish'] != adoptionDateTimeWishArray[1]) {
          fieldValueChanged = true;
        }

        this.burialDates['adoptionDateWish'] = adoptionDateTimeWishArray[0];
        this.modalService.didInputForClass('adoptionDateWish');
        this.burialDates['adoptionTimeWish'] = adoptionDateTimeWishArray[1];
        this.modalService.didInputForClass('adoptionTimeWish');
        this.modalService.setModalData('burialDates', this.burialDates);
      }
    } else if (fieldClass == 'anonymousBurialSiteDateTimeWish') {
      var anonymousBurialSiteDateTimeWishArray = fieldValue.split(' ');
      if (anonymousBurialSiteDateTimeWishArray.length > 1) {

        if (this.burialDates['anonymousBurialSiteDateWish'] != anonymousBurialSiteDateTimeWishArray[0] || this.burialDates['anonymousBurialSiteTimeWish'] != anonymousBurialSiteDateTimeWishArray[1]) {
          fieldValueChanged = true;
        }

        this.burialDates['anonymousBurialSiteDateWish'] = anonymousBurialSiteDateTimeWishArray[0];
        this.modalService.didInputForClass('anonymousBurialSiteDateWish');
        this.burialDates['anonymousBurialSiteTimeWish'] = anonymousBurialSiteDateTimeWishArray[1];
        this.modalService.didInputForClass('anonymousBurialSiteTimeWish');
        this.modalService.setModalData('burialDates', this.burialDates);
      }
    } else if (fieldClass == 'mourningHallUse') {
      this.burialDates[fieldClass] = this.mourningHallUse;
      this.modalService.didInputForClass(fieldClass);
      this.modalService.setModalData('burialDates', this.burialDates);
    } else {
      this.burialDates[fieldClass] = fieldValue;
      this.modalService.didInputForClass(fieldClass);
      this.modalService.setModalData('burialDates', this.burialDates);
    }

    if (fieldClass == 'anonymousBurialSite') {
      this.burialServiceDateWishIndicator = true;
      this.anonymousBurialSite = fieldValue;
      this.changeDetectorRef.detectChanges();
    } else if (fieldClass == 'driveServiceDateTimeWishFrom' || fieldClass == 'driveServiceDateTimeWishTo') {
      if (fieldValue && fieldValue.length > 0) {
        this.driveServiceDateWishIndicator = true;
      } else {
        this.driveServiceDateWishIndicator = false;
      }
      this.changeDetectorRef.detectChanges();
    } else if (fieldClass == 'adoptionType') {
      if (fieldValueChanged && fieldValue > 0) {
        this.adoptionTypeIndicator = true;
      } else {
        this.adoptionTypeIndicator = false;
      }
      this.changeDetectorRef.detectChanges();
    }

    initBurialDates((pickerComponent: any, dateTime: any, type: string) => {
      this.requestAllowedTimesUpdate(pickerComponent, dateTime, type);
    });
  }

  requestAllowedTimesUpdate(pickerComponent: any, dateTime: any, type: string) {
    this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.calendar, null, (success, response) => {
      if (!success || !response || !response.success || !response.hasOwnProperty('payload') || !response.payload || !response.payload.hasOwnProperty('timeblocks') || !response.payload.timeblocks) { return; }

      localStorage.setItem('blockedDates', JSON.stringify(response.payload.timeblocks));

      toggleLoadingSpinner(false);

      var currentAllowedTimes = getAllowedTimesArray(dateTime, type);

      if (currentAllowedTimes) {
        pickerComponent.setOptions({
          allowTimes: currentAllowedTimes,
          maxDate: false
        });

        setPickerTimeBoxVisible(true);
      }
    });
  }

  setValueForKey(fieldClass?: string, value?: any) {
    if ((fieldClass == 'driveServiceDateTimeWishFrom' || fieldClass == 'driveServiceDateTimeWishTo') && value.length > 0) {
      this.driveServiceDateWishIndicator = true;
    } else if (fieldClass == 'adoptionType' && value > 0) {
      this.adoptionTypeIndicator = true;
    } else if (fieldClass == 'anonymousBurialSite') {
      this.burialServiceDateWishIndicator = true;
      this.anonymousBurialSite = value;
    } else if (fieldClass == 'anonymousBurialContract') {
      if (this.burialDates && this.burialDates.anonymousBurialSite == 15) {
        fieldClass = 'anonymousBurialContractOne';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 48) {
        fieldClass = 'anonymousBurialContractTwo';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 8) {
        fieldClass = 'anonymousBurialContractThree';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 46) {
        fieldClass = 'anonymousBurialContractFour';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 49) {
        fieldClass = 'anonymousBurialContractFive';
      } else if (this.burialDates && (this.burialDates.anonymousBurialSite == 1 || this.burialDates.anonymousBurialSite == 2 || this.burialDates.anonymousBurialSite == 5 || this.burialDates.anonymousBurialSite == 7 || this.burialDates.anonymousBurialSite == 43)) {
        fieldClass = 'anonymousBurialContractSix';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 6) {
        fieldClass = 'anonymousBurialContractSeven';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 14) {
        fieldClass = 'anonymousBurialContractEight';
      } else if (this.burialDates && (this.burialDates.anonymousBurialSite == 21 || this.burialDates.anonymousBurialSite == 29)) {
        fieldClass = 'anonymousBurialContractNine';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 50) {
        fieldClass = 'anonymousBurialContractTen';
      } else if (this.burialDates && this.burialDates.anonymousBurialSite == 51) {
        fieldClass = 'anonymousBurialContractEleven';
      } else {
        fieldClass = undefined;
      }
    } else if (fieldClass == 'anonymousBurialType') {
      if (this.burialDates && this.burialDates.anonymousBurialSite != 41 && this.burialDates.anonymousBurialSite != 42 && this.burialDates.anonymousBurialSite != 34 && this.burialDates.anonymousBurialSite != 35 && this.burialDates.anonymousBurialSite != 36 && this.burialDates.anonymousBurialSite != 37 && this.burialDates.anonymousBurialSite != 38 && this.burialDates.anonymousBurialSite != 40) {
        fieldClass = 'anonymousBurialTypeOne';
      } else if (this.burialDates && (this.burialDates.anonymousBurialSite == 41 || this.burialDates.anonymousBurialSite == 35 || this.burialDates.anonymousBurialSite == 36 || this.burialDates.anonymousBurialSite == 37 || this.burialDates.anonymousBurialSite == 38)) {
        fieldClass = 'anonymousBurialTypeTwo';
      } else if (this.burialDates && (this.burialDates.anonymousBurialSite == 42 || this.burialDates.anonymousBurialSite == 34 || this.burialDates.anonymousBurialSite == 40)) {
        fieldClass = 'anonymousBurialTypeThree';
      }
    }

    setTimeout(() => {
      if (fieldClass) {
        const field = this.credentialsService.parseElementBy(ElementAttribute.class, fieldClass);
        if (!field) { return; }
  
        if (fieldClass.indexOf('Switch') >= 0) {
          if (value && value == 1) {
            value = true;
          } else {
            value = false;
          }
          if (fieldClass == 'inputTreeNumberSwitch') {
            this.showInputTreeNumber = !value;
          }
          field.checked = value;
        } else {
          field.value = value;
        }
      }
    }, 0);
  }

  private initInputFieldsWithValuesFromServer() {
    if (this.burialDates) {
      for (var key in this.burialDates) {
        var keyToSet = key;
        var valueToSet = this.burialDates[key];
        if (!valueToSet) {
          continue;
        }
        if (key == 'driveServiceDateWishFrom' || key == 'driveServiceTimeWishFrom') {
          keyToSet = 'driveServiceDateTimeWishFrom';
          valueToSet = this.burialDates['driveServiceDateWishFrom'] + ' ' + this.burialDates['driveServiceTimeWishFrom'];
        }
        if (key == 'driveServiceDateWishTo' || key == 'driveServiceTimeWishTo') {
          keyToSet = 'driveServiceDateTimeWishTo';
          valueToSet = this.burialDates['driveServiceDateWishTo'] + ' ' + this.burialDates['driveServiceTimeWishTo'];
        }
        if (key == 'adoptionDateWish' || key == 'adoptionTimeWish') {
          keyToSet = 'adoptionDateTimeWish';
          valueToSet = this.burialDates['adoptionDateWish'] + ' ' + this.burialDates['adoptionTimeWish'];
        }
        if (key == 'anonymousBurialSiteDateWish' || key == 'anonymousBurialSiteTimeWish') {
          keyToSet = 'anonymousBurialSiteDateTimeWish';
          valueToSet = this.burialDates['anonymousBurialSiteDateWish'] + ' ' + this.burialDates['anonymousBurialSiteTimeWish'];
        }
        if (keyToSet && valueToSet) {
          this.setValueForKey(keyToSet, valueToSet);
        }
      }

      initSelect();
    }
  }

  //This function is the old urn_delivery controller, and should only be used when showing urn_delivery
  insertDataToFields() {
    if (!this.modalService.selectedTab || this.modalService.selectedTab != SelectedBurialsTab.urnDelivery) { return; }

    const newData = this.modalService.getModalData();
    if (newData && newData != this.urnDeliveryDataCache) {
      this.urnDeliveryDataCache = newData;
    }

    this.setValueForKey('driveServiceDateTimeWish', this.burialsService.readableDateFromString(this.urnDeliveryDataCache.s_driveserviceDateWish) + ' ' + this.burialsService.readableTimeFromString(this.urnDeliveryDataCache.s_driveserviceTimeWish) + ' Uhr');
    this.setValueForKey('adoptionType', this.burialsService.readableAdoptionTypeByID(this.urnDeliveryDataCache.adoptiontype));
    this.setValueForKey('adoptionTypeTest', this.burialsService.readableAdoptionTypeByID(this.urnDeliveryDataCache.adoptiontype));
        this.setValueForKey('adoptionDateTimeWish', this.burialsService.readableDateFromString(this.urnDeliveryDataCache.adoptiondate) + ' ' + this.burialsService.readableTimeFromString(this.urnDeliveryDataCache.adoptiontime) + ' Uhr');
    this.setValueForKey('anonymousBurialSiteDateTimeWish', this.burialsService.readableDateFromString(this.urnDeliveryDataCache.s_anonymousBurialSiteDateWish) + ' ' + this.burialsService.readableTimeFromString(this.urnDeliveryDataCache.s_anonymousBurialSiteTimeWish) + ' Uhr');
  }

  openedCollapsiblePart() {
    updateMaterialTextFields();

    initBurialDates((pickerComponent: any, dateTime: any, type: string) => {
      this.requestAllowedTimesUpdate(pickerComponent, dateTime, type);
    });
  }

  // Hilfsfunktion zum Parsen von deutschem Datum/Zeit Format (dd.mm.yyyy HH:mm)
  private parseGermanDateTime(dateTimeString: string): string {
    if (!dateTimeString || dateTimeString.length === 0) {
      return '';
    }
    
    const parts = dateTimeString.split(' ');
    if (parts.length !== 2) {
      return '';
    }
    
    const datePart = parts[0].split('.');
    const timePart = parts[1].split(':');
    
    if (datePart.length !== 3 || timePart.length !== 2) {
      return '';
    }
    
    // Konvertiere dd.mm.yyyy HH:mm zu yyyy-mm-ddTHH:mm für Date-Objekt
    const year = datePart[2];
    const month = datePart[1].padStart(2, '0');
    const day = datePart[0].padStart(2, '0');
    const hours = timePart[0].padStart(2, '0');
    const minutes = timePart[1].padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:00`;
  }

  // Hilfsfunktion zum Formatieren von Date zu deutschem Datum (dd.mm.yyyy)
  private formatGermanDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  // Hilfsfunktion zum Formatieren von Date zu deutscher Zeit (HH:mm)
  private formatGermanTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

}
